import React, { useState, useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';

import ImageComponent from 'atoms/Image';

import { UserOrderContext } from 'context/context';
import { LOCAL_STORAGE_KEYS, ROUTE_URL } from 'common/constants/SharedConstants';
import { isEmptyEvery, isMobileDevice, checkActiveOrderPage } from 'common/utilities/utils';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { useHistory } from 'react-router-dom';
import HEADER_CONSTANT from 'organisms/HeaderComponent/AU/HeaderConstants/HeaderConstant';
import { modifyData, getSecondaryHeadertitle } from 'organisms/HeaderComponent/AU/HeaderUtilities/HeaderUtils';
import { SecondaryHeaderNavLink } from 'organisms/HeaderComponent/AU/Presentation/SharedTemplates/SecondaryHeaderNavLink';
import { HeaderSigninComp } from 'organisms/HeaderComponent/AU/Presentation/SharedTemplates/HeaderSigninComp';
import NeedHelp from 'organisms/NeedHelp/Container/NeedHelp';
import { ButtonType, ContainedButton } from '../../../../atoms/Buttons';
import { getTernaryValue, redirectToHomePage } from '../../../../common/utilities/utils';
import { isAddHopePurchase } from 'common/utilities/orderStatusUtils';
import { isGiftCardPurchase,isGetGiftCardDetails } from '../../../../common/utilities/orderStatusUtils';

export const getBackToCart = () => {
  return isAddHopePurchase() ? HEADER_CONSTANT.GO_BACK : HEADER_CONSTANT.BACK_TO_CART;
};

export const getRoutePath = () => {
  return isAddHopePurchase() ? ROUTE_URL.HOME_PAGE : ROUTE_URL.CART;
};

export const getButtonContent = checkoutHeader => {
  return checkoutHeader ? (
    <span data-testid='back-to-cart-btn' className='back-text'>
      {translateWithI18Next(getBackToCart())}
    </span>
  ) : (
    <span data-testid='goto-home-btn' className='back-text'>
      {translateWithI18Next(HEADER_CONSTANT.GO_BACK)}
    </span>
  );
};

export const getPathName = checkoutHeader => {
  return checkoutHeader ? getRoutePath() : ROUTE_URL.HOME_PAGE;
};

export const needHelpClass = (checkoutHeader, multiDeliverySupport) => {
  return `need-help-container right-nav-item${checkoutHeader ? '' : ' payment-help-btn'} ${
    multiDeliverySupport ? 'disable-supportbtn' : ''
  }`;
};

const SecondaryHeaderItems = props => {
  const {
    contentData,
    tenantReducerData = {},
    checkoutHeader = false,
    showOrderSummaryHeader = false,
    showBackToCart = false,
    showNeedHelp = false,
    showMobileKfcLogo = false,
    hideNeedHelpModal= false
  } = props;
  const history = useHistory();
  const { basic } = tenantReducerData;
  const { showSecondaryHeader = false } = tenantReducerData?.componentOptions?.web?.global || {};

  const { NEED_HELP } = HEADER_CONSTANT;

  const { navRight, kfcLogo } = modifyData(contentData, basic);

  const { HOME_PAGE } = ROUTE_URL;
  const { userOrderState } = useContext(UserOrderContext);

  const dispositionNew = isEmptyEvery(userOrderState?.dispositionNew)
    ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS?.DISPOSITION_NEW))
    : userOrderState.dispositionNew;

  const [multiDeliverySupport, setMultiDeliverySupport] = useState(false);
  const [openModal, toggleModal] = useState(false);
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { postOrderReducer } = useSelector(data => data);
  const { showNeedhelpModal = false } = tenantReducer?.componentOptions?.web?.global || {};
  const {isWicodeFinaliseFailed} = postOrderReducer?.orderAccepted;
  const closeModal = () => {
    toggleModal(false);
  };
  useEffect(() => {
    if (window?.location?.pathname === '/order-summary') {
      setMultiDeliverySupport(true);
      if (postOrderReducer?.orderAccepted?.deliveryPartners) {
        setMultiDeliverySupport(false);
      } else {
        setMultiDeliverySupport(true);
      }
    }
  }, [history, postOrderReducer]);


  console.log((showNeedhelpModal || !isGiftCardPurchase()) || (showNeedhelpModal || !isGetGiftCardDetails()),"tst")
  return (
    <div data-testid='secondary-header-container' className='secondary-header-container'>
      {window?.location?.pathname !== ROUTE_URL?.ORDER_PROCESSING && showBackToCart  && (
        <div className='back-button-container'>
          <SecondaryHeaderNavLink pathname={getPathName(checkoutHeader)} setOrderComplete={!checkoutHeader}>
            {(isMobileDevice(window.innerWidth) || isGiftCardPurchase() ) ? (
              <ImageComponent
                srcFile={IMAGE_PATH?.ArrowIcon}
                className={getTernaryValue(checkoutHeader, 'back-icon', 'display-none')}
                alt='Back to Cart'
              />
            ) : (
              <ContainedButton variant={ButtonType.tertiary}>{getButtonContent(checkoutHeader)}</ContainedButton>
            )}
          </SecondaryHeaderNavLink>
          {!hideNeedHelpModal && showNeedhelpModal && (!isGiftCardPurchase() || !isGetGiftCardDetails()) && (
            <div data-testid='help-btn' className={`payment-help-container`} onClick={() => toggleModal(true)}>
              <ImageComponent
                srcFile={IMAGE_PATH?.HelpIcon}
                className={checkoutHeader ? 'display-none' : 'help-icon'}
                alt='help icon'
              />
            </div>
          )}
        </div>
      )}

      <div className='kfc-header-container'>
        {!showMobileKfcLogo && (
          <SecondaryHeaderNavLink data-testid='home-btn' pathname={HOME_PAGE} setOrderComplete={!checkoutHeader}>
            <ImageComponent
              className='kfc-header-icon'
              srcFile={kfcLogo?.src || IMAGE_PATH?.HeaderLogo}
              alt={kfcLogo?.alt}
            />
          </SecondaryHeaderNavLink>
        )}
        {!showMobileKfcLogo && (
          <span className='text-icon'>
            {getSecondaryHeadertitle(checkoutHeader, showOrderSummaryHeader, dispositionNew, isWicodeFinaliseFailed)}
          </span>
        )}
        {showMobileKfcLogo && (
          <div data-testid='kfc-logo' className={`header-logo-mobile`} onClick={() => redirectToHomePage({ history })}>
            <ImageComponent srcFile={kfcLogo?.src || IMAGE_PATH?.HeaderLogo} alt='KFC LOGO' />
          </div>
        )}
      </div>
      {window?.location?.pathname !== ROUTE_URL?.ORDER_PROCESSING && showNeedHelp && (
        <div className='right-nav-container'>
          {hideNeedHelpModal && showNeedhelpModal && (
            <div
              data-testid='help-btn ac'
              className={needHelpClass(checkoutHeader, multiDeliverySupport)}
              onClick={() => toggleModal(true)}
            >
              <ImageComponent srcFile={IMAGE_PATH?.HelpIcon} className='help-icon' alt='help icon' />
              <span className='help-text'>{translateWithI18Next(NEED_HELP)}</span>
            </div>
          )}
          {checkoutHeader && showSecondaryHeader ? (
            <HeaderSigninComp data-testid='sign-in-container' navRight={navRight} />
          ) : null}
          <SecondaryHeaderNavLink
            pathname={HOME_PAGE}
            setOrderComplete
            data-testid='header-close-btn'
            className={checkoutHeader ? 'display-none' : 'header-close-btn'}
          >
            <ImageComponent srcFile={IMAGE_PATH?.PopupCloseBtn} alt='close-btn' />
          </SecondaryHeaderNavLink>
        </div>
      )}
      {openModal && (
        <NeedHelp
          isOpen={openModal}
          orderHistoryPage={checkActiveOrderPage()}
          checkoutHeader={checkoutHeader}
          showOrderSummaryHeader={showOrderSummaryHeader}
          handleClose={() => closeModal()}
        />
      )}
    </div>
  );
};

export default SecondaryHeaderItems;
